<script>
import paper from 'paper';
import { mapMutations } from 'vuex';
import tool from '../mixins/tool';
// import UndoAction from "../undo";

import { invertColor } from '../libs/colors';
import { BBox } from '../libs/bbox';
import iconImg from '../images/bbox-1.png';
import iconImgActive from '../images/bbox-active.png';

export default {
    name: 'BBoxTool',
    mixins: [tool],
    props: {
        scale: {
            type: Number,
            default: 1,
        },
        settings: {
            type: [Object, null],
            default: null,
        },
        // 是否允许绘制，编辑
        enable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            toolTipText: {
                // 工具提示
                zh: '矩形绘制工具', // 中文
                en: 'BBoxTool tool', // 英文
            },
            iconImage: iconImg,
            iconImageActive: iconImgActive,
            icon: 'fa-object-group',
            name: 'BBox',
            scaleFactor: 3,
            cursor: 'crosshair',
            bbox: null,
            polygon: {
                path: null,
                guidance: true,
                pathOptions: {
                    strokeColor: 'black',
                    strokeWidth: 1,
                },
            },
            color: {
                blackOrWhite: true,
                auto: true,
                radius: 10,
                circle: null,
            },
            actionTypes: Object.freeze({
                ADD_POINTS: 'Added Points',
                CLOSED_POLYGON: 'Closed Polygon',
                DELETE_POLYGON: 'Delete Polygon',
            }),
            actionPoints: 0,
        };
    },
    methods: {
        ...mapMutations('annotator', ['addUndo', 'removeUndos']),
        export() {
            return {
                completeDistance: this.polygon.completeDistance,
                minDistance: this.polygon.minDistance,
                blackOrWhite: this.color.blackOrWhite,
                auto: this.color.auto,
                radius: this.color.radius,
            };
        },

        // 设置首选项
        setPreferences(pref) {
            this.color.blackOrWhite = pref.blackOrWhite || this.color.blackOrWhite;
            this.color.auto = pref.auto || this.color.auto;
            this.color.radius = pref.radius || this.color.radius;
        },

        // 创建
        createBBox(event) {
            this.polygon.path = new paper.Path(this.polygon.pathOptions);
            this.bbox = new BBox(event.point);
            this.bbox.getPoints().forEach((point) => this.polygon.path.add(point));
        },

        // 修改
        modifyBBox(event) {
            this.polygon.path = new paper.Path(this.polygon.pathOptions);
            this.bbox.modifyPoint(event.point);
            this.bbox.getPoints().forEach((point) => this.polygon.path.add(point));
        },
        /**
         * Frees current bbox
         * 删除
         */
        deleteBbox() {
            if (this.polygon.path == null) return;

            this.polygon.path.remove();
            this.polygon.path = null;

            if (this.color.circle == null) return;
            this.color.circle.remove();
            this.color.circle = null;
        },
        // 自动笔划颜色
        autoStrokeColor(point) {
            if (this.color.circle == null) return;
            if (this.polygon.path == null) return;
            if (!this.color.auto) return;

            this.color.circle.position = point;
            let raster = this.$parent.image.raster;
            let color = raster.getAverageColor(this.color.circle);
            if (color) {
                this.polygon.pathOptions.strokeColor = invertColor(
                    color.toCSS(true),
                    this.color.blackOrWhite,
                );
            }
        },
        // 检查注释是否存在
        checkAnnotationExist() {
            return (
                !!this.$parent.currentAnnotation
                && !!this.$parent.currentAnnotation.annotation.paper_object.length
            );
        },
        // 鼠标向下
        onMouseDown(event) {
            if (!this.enable) return;
            if (this.polygon.path == null && this.checkAnnotationExist()) {
                // this.$parent.currentCategory.createAnnotation();
            }
            if (this.polygon.path == null) {
                this.createBBox(event);
                return;
            }
            this.removeLastBBox();
            this.modifyBBox(event);

            // eslint-disable-next-line no-useless-return
            if (this.completeBBox()) return;
        },

        // 鼠标移动
        onMouseMove(event) {
            if (!this.enable) return;
            if (this.polygon.path == null) return;
            if (this.polygon.path.segments.length === 0) return;
            this.autoStrokeColor(event.point);
            this.removeLastBBox();
            this.modifyBBox(event);
        },
        /**
         * Undo points
         * 撤消点
         */
        undoPoints(args) {
            if (this.polygon.path == null) return;

            let points = args.points;
            let length = this.polygon.path.segments.length;
            this.polygon.path.removeSegments(length - points, length);
        },
        /**
         * Closes current polygon and unites it with current annotaiton.
         * 关闭当前多边形并将其与当前标注合并。
         * @returns {boolean} sucessfully closes object
         */
        completeBBox() {
            if (this.polygon.path == null) return false;

            this.polygon.path.fillColor = 'black';
            this.polygon.path.closePath();
            this.$parent.uniteCurrentAnnotation(this.polygon.path, true, true, true);

            this.polygon.path.remove();
            this.polygon.path = null;
            if (this.color.circle) {
                this.color.circle.remove();
                this.color.circle = null;
            }

            this.removeUndos(this.actionTypes.ADD_POINTS);
            return true;
        },
        // 删除最后一个
        removeLastBBox() {
            this.polygon.path.removeSegments();
        },
    },
    computed: {
        isDisabled() {
            // return this.$parent.current.annotation === -1 && this.$parent.current.category === -1;
            if (!this.enable) return true;
            return (
                (this.$parent.current.annotation === -1 && this.$parent.current.category === -1)
                || this.currentAnnotatorHashPath
            );
        },
    },
    watch: {
        isActive(active) {
            if (active) {
                this.tool.activate();
                localStorage.setItem('editorTool', this.name);
            }
        },
        /**
         * Change width of stroke based on zoom of image
         * 基于图像缩放更改笔划宽度
         */
        scale(newScale) {
            this.polygon.pathOptions.strokeWidth = newScale * this.scaleFactor;
            if (this.polygon.path != null) {
                this.polygon.path.strokeWidth = newScale * this.scaleFactor;
            }
        },
        'polygon.pathOptions.strokeColor': function (newColor) {
            if (this.polygon.path == null) return;

            this.polygon.path.strokeColor = newColor;
        },
        'color.auto': function (value) {
            if (value && this.polygon.path) {
                this.color.circle = new paper.Path.Rectangle(new paper.Point(0, 0), new paper.Size(10, 10));
            }
            if (!value && this.color.circle) {
                this.color.circle.remove();
                this.color.circle = null;
            }
        },
    },
    created() {},
    mounted() {},
};
</script>
